module.exports = __webpack_public_path__ + "media/icons/fuel-8d917683.svg";